import * as React from 'react';
const SvgMedical = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={640} height={640} viewBox='0 0 60 60' {...props}>
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='M16.46 4.32h.281l.057.126.127.253.14.254.152.257.164.257.177.258.189.259.2.259.211.259.223.259.235.259.244.258.256.258.266.256.276.255.287.253.296.251.306.249.316.247.324.244.334.241.343.238.351.235.36.231.368.227.376.223.384.218.391.214.399.209.406.203.317.153.316.147.316.141.315.137.315.131.314.126.313.121.312.115.311.11.31.104.308.1.306.093.305.089.302.083.301.078.298.073.296.067.293.062.291.057.288.051.285.046.282.04.278.036.275.03.225.02.009.128.015.375.005.384V26.5l-.005.387-.015.385-.025.382-.035.38-.044.376-.054.374-.064.371-.072.367-.082.364-.091.36-.1.357-.108.353-.118.349-.125.345-.134.341-.143.336-.15.333-.159.327-.166.324-.175.318-.182.314-.189.308-.197.303-.204.299-.211.292-.218.287-.226.282-.232.276-.238.27-.245.264-.252.257-.257.252-.264.245-.27.238-.276.232-.282.226-.287.218-.292.211-.299.204-.303.197-.308.189-.314.182-.318.175-.324.166-.327.159-.333.15-.336.143-.341.134-.345.125-.349.118-.353.108-.357.1-.36.091-.364.082-.367.072-.371.064-.374.054-.376.044-.38.035-.382.025-.385.015-.387.005h-1.4l-.387-.005-.385-.015-.382-.025-.38-.035-.376-.044-.374-.054-.371-.064-.367-.072-.364-.082-.36-.091-.357-.1-.353-.108-.349-.118-.345-.125-.341-.134-.336-.143-.333-.15-.327-.159-.324-.166-.318-.175-.314-.182-.308-.189-.303-.197-.299-.204-.292-.211-.287-.218-.282-.226-.276-.232-.27-.238-.264-.245-.257-.252-.252-.257-.245-.264-.238-.27-.232-.276-.226-.282-.218-.287-.211-.292-.204-.299-.197-.303-.189-.308-.182-.314-.175-.318-.166-.324-.159-.327-.15-.333-.143-.336-.134-.341-.125-.345-.118-.349-.108-.353-.1-.357-.091-.36-.082-.364-.072-.367-.064-.371-.054-.374L2 28.034l-.035-.38-.025-.382-.015-.385-.005-.387V14.854l.005-.384.015-.376.025-.367.014-.14.115-.019.288-.051.291-.057.293-.062.296-.067.298-.073.301-.078.302-.083.305-.089.306-.093.308-.1.31-.104.311-.11.312-.115.313-.121.314-.126.315-.131.315-.137.316-.141.316-.147.317-.153.406-.203.399-.209.391-.214.384-.218.376-.223.368-.227.36-.231.351-.235.343-.238.334-.241.324-.244.316-.247.306-.249.296-.251.287-.253.276-.255.266-.256.256-.258.244-.258.235-.259.223-.259.211-.259.2-.259.189-.259.177-.258.164-.257.152-.257.14-.254.127-.253.057-.126h.081'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.424844}
      d='M13.679 15.906h6.625v5.665l5.842-.052.055 6.132-5.897.053v5.872H13.68v-5.811l-5.668.05-.055-6.132 5.723-.051v-5.726'
    />
    <circle
      cx={3.24}
      cy={3.24}
      r={3.24}
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      transform='rotate(1.194 -79.526 1980.088)'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='m44.247 8.917-.172 4.477-7.828 6.95 12.63 4.345-8.22 4.996 4.91 2.336-.257 6.942'
    />
  </svg>
);
export default SvgMedical;
